
import { mapMutations, mapState, mapGetters } from "vuex";
export default {
  data() {
    return {
      selectedBrand: ""
    };
  },
  mounted() {
    this.selectedBrand = this.brandFilter;
  },
  computed: {
    ...mapState("menu", ["brandFilter"]),
    ...mapGetters("restaurant", ["getAllBrands", "getRestaurantName"])
  },
  methods: {
    ...mapMutations("menu", ["SET_BRAND_FILTER"]),
    filterChanged(val) {
      this.SET_BRAND_FILTER(val);
    }
  }
};
